import React from "react"

const FreeDiscoveryCallBlock = ({ practice, theme }) => {
  // Find the first free service
  const freeService = practice.services.find((service) => service.amountCents === 0)

  if (!freeService) {
    return null
  }

  const handleBookFree = () => {
    window.location.href = `/${practice.user.slug}/services/${freeService.id}`
  }

  return (
    <div className="mb-8 rounded-lg p-6" style={{ backgroundColor: theme.colorGreyLightest }}>
      <div className="flex flex-row items-center justify-between gap-4 sm:flex-col sm:items-start">
        <div className="flex-1">
          <h3
            className="mb-2 text-2xl font-bold leading-tight"
            style={{
              color: theme.colorTextDark,
              fontFamily: theme.fontHeading,
              fontWeight: theme.fontHeadingWeight
            }}>
            Book a free discovery call
          </h3>
          <p className="text-base leading-normal" style={{ color: theme.colorTextDark }}>
            Learn more about this practitioner and event.
          </p>
        </div>

        <button
          onClick={handleBookFree}
          className="whitespace-nowrap rounded px-6 py-3 font-semibold leading-normal transition-colors hover:opacity-90"
          style={{
            backgroundColor: practice.theme.colorAccent,
            color: practice.theme.colorBgLight
          }}>
          Book for free
        </button>
      </div>
    </div>
  )
}

export default FreeDiscoveryCallBlock
